import React from "react";
import { Row, Col, Typography, Space, Grid, Card, Rate ,Button} from "antd";
import MigrationImg from "../../assets/images/MigrationImg.svg";
import MigrationImg2 from "../../assets/images/MigrationImg2.svg";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const reviews = [
  {
    text: "Most of the time if there is something I am not sure how to do, I can find an article all about it in their support section. If I can't find a solution I just hop on the live chat and someone is there to help.",
  },
  {
    text: "I work with almost every hosting company every day, and none of them is as simple as Hostinger when managing hosting, SSL, email, file management, domain management and client management.",
  },
  {
    text: "The most helpful thing about Hostinger is the ease of setting up and getting everything up and running. The quick turnaround is what makes this platform different from the others. Plus, the pricing is super competitive, if not the best, currently.",
  },
];

export default function MigrationSection() {
  const screens = useBreakpoint();

  return (
    <div style={{ background: "#ffffff" }}>
      {/* ================= MIGRATION SECTION ================= */}
      <div
        style={{
          padding: screens.md ? "80px 24px 40px" : "40px 16px 32px",
        }}
      >
        <div
          style={{
            maxWidth: 1128,
            height: screens.md ? 400 : "auto",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Row align="middle" gutter={[48, 48]} style={{ width: "100%" }}>
            {/* LEFT IMAGE */}
            <Col
              xs={24}
              md={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={MigrationImg}
                alt="Website Migration"
                style={{
                  width: "100%",
                  maxWidth: 552,
                  height: "auto",
                  display: "block",
                }}
              />
            </Col>

            {/* RIGHT CONTENT */}
            <Col xs={24} md={12}>
              <Space
                direction="vertical"
                size="middle"
                style={{ width: "100%" }}
              >
                <Title level={2} style={{ color: "#2d1e6b", marginBottom: 8 }}>
                  Migrate to Hostinger effortlessly
                </Title>

                <Text style={{ color: "#2d1e6b", fontSize: 15 }}>
                  • Move as many websites as you want for free with our{" "}
                  <strong>automatic website migration tool</strong>.
                </Text>

                <Text style={{ color: "#2d1e6b", fontSize: 15 }}>
                  • Sit back and relax — our{" "}
                  <strong>dedicated migration team</strong> will ensure a smooth
                  transfer.
                </Text>

                <Text style={{ color: "#2d1e6b", fontSize: 15 }}>
                  • <strong>No disruption</strong> — your website will stay
                  online during the entire migration process.
                </Text>
              </Space>
            </Col>
          </Row>
        </div>
      </div>

      {/* ================= REVIEWS SECTION ================= */}
      <div
        style={{
          padding: screens.md ? "40px 24px 80px" : "32px 16px 60px",
        }}
      >
        <div style={{ maxWidth: 1128, margin: "0 auto" }}>
          <Row gutter={[24, 24]}>
            {reviews.map((review, index) => (
              <Col xs={24} md={8} key={index}>
                <Card
                  //bordered
                  style={{
                    height: "100%",
                      borderRadius: 12,
                    border: "1px solid #e6eaff",
                  }}
                >
                  {/*  icon */}
                  <div style={{ marginBottom: 16 }}>
                    <img
                      src={MigrationImg2}
                      alt="Review source"
                      style={{
                        width: '100%',
                        height: 'auto',
                        display: "block",
                      }}
                    />
                  </div>

                  {/* Review text */}
                  <Text
                    style={{
                      color: "#2d1e6b",
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    {review.text}
                  </Text>

                  {/* Stars */}
                  <div style={{ marginTop: 24 }}>
                    <Rate
                      disabled
                      defaultValue={5}
                      style={{ color: "#ff4d4f" }}
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
     
        {/* CTA SECTION (INSIDE REVIEWS) */}
        <div style={{ marginTop: 80, textAlign: "center" }}>
          <Space direction="vertical" size={24} align="center">
            <Title
              level={2}
              style={{
                margin: 0,
                color: "#2d1e6b",
                fontWeight: 700,
              }}
            >
              Join over 3 million website owners
            </Title>

            <Button
              type="primary"
              size="large"
              style={{
                background: "#673DE6",
                borderRadius: 8,
                height: 48,
                padding: "0 32px",
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              Get started
            </Button>

            <Text style={{ fontSize: 13, color: "#2d1e6b" }}>
              30-Day Money-Back Guarantee
            </Text>
          </Space>
        </div>
      </div>
    </div>
  );
}
